import React from 'react';
import foundationLogo from '../../../assets/img/foundation_finance.png';
import '../../../pages/Optimus/Foundation/Foundation.scss';

const FoundationLogo = ({ className }) => (
  <img src={foundationLogo} className={(className, 'max-width-logo')} alt="Foundation logo" />
);

export default FoundationLogo;
